import React, { createContext, useState } from "react";
import PropTypes from "prop-types";

export const AddOnsContext = createContext();

export const AddOnsContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <AddOnsContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
      }}
    >
      {children}
    </AddOnsContext.Provider>
  );
};

export default AddOnsContextProvider;
AddOnsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
